import { JwtTokenService } from '@dangl/angular-dangl-identity-client';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'da-hangfire-dashboard',
    templateUrl: './hangfire-dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./hangfire-dashboard.component.scss']
})
export class HangfireDashboardComponent implements OnInit, OnDestroy {
  private jwtTokenService = inject(JwtTokenService);
  private sanitizer = inject(DomSanitizer);

  dashboardUrl = signal<SafeUrl>(null);

  private $destroy = new Subject<boolean>();

  ngOnInit(): void {
    this.jwtTokenService
      .getToken()
      .pipe(takeUntil(this.$destroy))
      .subscribe(t => {
        const dashboardUrl = `/hangfire/dashboard?access_token=${t?.accessToken}`;
        this.dashboardUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(dashboardUrl));
      });
  }

  ngOnDestroy(): void {
    this.$destroy.next(true);
    this.$destroy.complete();
  }
}
